import { carouselData } from '@/mocks/comicData';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {carouselData.title}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselData.items.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group ${
                idx === 4 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[11px] rounded-full bg-primary-500 text-background-50 font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}